import type { SchedulingProvider } from '@core/supabase/services/interviewEventService';

const STORAGE_KEY = 'ggj_b2b_interview_wizard_draft_v1';

export type InterviewWizardDraft = {
  step: number;
  applicationId: string;
  round: number;
  interviewerName: string;
  interviewerEmail: string;
  panelists: { name: string; email: string }[];
  candidateAvailability: string;
  panelAvailability: string;
  mode: 'self_book' | 'fixed';
  provider: SchedulingProvider | '';
  bookingUrl: string;
  fixedWhen: string;
  fixedLocation: string;
  fixedDuration: string;
  notes: string;
};

/** Build value for `<input type="datetime-local" />` in local timezone. */
export function formatDaySeedForDatetimeLocal(d: Date, hour = 9, minute = 0): string {
  const x = new Date(d);
  x.setHours(hour, minute, 0, 0);
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, '0');
  const day = String(x.getDate()).padStart(2, '0');
  const h = String(x.getHours()).padStart(2, '0');
  const min = String(x.getMinutes()).padStart(2, '0');
  return `${y}-${m}-${day}T${h}:${min}`;
}

export const defaultInterviewWizardDraft = (): InterviewWizardDraft => ({
  step: 0,
  applicationId: '',
  round: 1,
  interviewerName: '',
  interviewerEmail: '',
  panelists: [{ name: '', email: '' }],
  candidateAvailability: '',
  panelAvailability: '',
  mode: 'self_book',
  provider: '',
  bookingUrl: '',
  fixedWhen: '',
  fixedLocation: '',
  fixedDuration: '60',
  notes: '',
});

export function loadInterviewWizardDraft(): InterviewWizardDraft | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as Partial<InterviewWizardDraft>;
    const step = Math.min(Math.max(0, Number(o.step) || 0), 4);
    return {
      ...defaultInterviewWizardDraft(),
      ...o,
      step,
      panelists: o.panelists?.length ? o.panelists : [{ name: '', email: '' }],
    };
  } catch {
    return null;
  }
}

export function saveInterviewWizardDraft(d: InterviewWizardDraft): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(d));
  } catch {
    /* ignore quota */
  }
}

export function clearInterviewWizardDraft(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
